import { TablePagination, Box, Button, Checkbox, Container, FormControlLabel, Grid, IconButton, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';
import { PDFDownloadLink } from '@react-pdf/renderer';
import GeneralPDF from '../InformesPDF/GeneralPDF';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const handleDownloadPdf = (name, data) => {
    const blobData = atob(data);
    const byteArray = new Uint8Array(blobData.length);
    for (let i = 0; i < blobData.length; i++) {
      byteArray[i] = blobData.charCodeAt(i);
    }
    const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

let desc = '';
let entradaIn = '';
let salidaIn = '';
let filasTotales = 0;
const opcionesFilasPorPagina = [5, 10, 25];

class ConsultaInformesUsuarios extends Component {
    constructor(props){
        super(props);
        this.state = {
            //------------------
            pagina: 0,
            filasPorPagina: 5,
            //------------------
            informesSolicitados: [],
            informesPendientes: [],
            informesNotificados: [],
            informesPendientesNotificacion: [],
            informesRechazados: [],
            codigosInforme: [],
            codigosEstadosInforme: [],
            lugaresTra: [],
            ubicacionesCentral: [],
            horasEntradas: [],
            informesAListar: [],
            busqueda: {
                numeroFuncionario: sessionStorage.numeroFuncionario,
                codigo: '',
            },

            datoEspecifico: {},

            errores: null,
            notificaciones: null,
            modalConsulta: false,

            checkInformes: {
                todos: true,
                pendientes: false,
                notificados: false,
                rechazados: false,
                pendienteNotificacion: false,
            },

            imagenMostrarModal: false,
            imagenMostrar: '',

        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarConsulta = this.manejarConsulta.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarEnvioNotificacion = this.manejarEnvioNotificacion.bind(this);
        this.cambioListadoConsulta = this.cambioListadoConsulta.bind(this);
        this.manejarVolver = this.manejarVolver.bind(this);
        this.manejarModalImagen = this.manejarModalImagen.bind(this);
        this.manejarCerrarModal = this.manejarCerrarModal.bind(this);
    }

    async componentDidMount(){
        const codInfo = await fetch(`${Constantes.RUTA_API}/obtener_codigosMovimientos.php`);
        const datosCodInfo = await codInfo.json();
        this.setState({
            codigosInforme: datosCodInfo,
        });

        const codEstadoInfo = await fetch(`${Constantes.RUTA_API}/obtener_codigosEstadosInforme.php`);
        const datosCodEstadoInfo = await codEstadoInfo.json();
        this.setState({
            codigosEstadosInforme: datosCodEstadoInfo,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });


        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });

        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntradas: datosEntrada,
        });
    }

    handleChangePage = (event, nuevaPagina) => {
        this.setState({ pagina: nuevaPagina });
    };
    
    handleChangeRowsPerPage = (event) => {
        const filasPorPagina = event.target.value === 'all' ? this.state.informesAListar.length : parseInt(event.target.value, 10);
        this.setState({ filasPorPagina, pagina: 0 });
    };

    render(){
        const { pagina, filasPorPagina } = this.state;
        filasTotales = this.state.informesAListar.length;
        return (
            <>
                {sessionStorage.login
                ?
                    <Container>
                        <h3>Informes</h3>
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        <br/>
                        {this.state.consulta
                        ?
                            null
                        :
                            <form onSubmit={this.manejoEnvioConsulta}>
                                <Box sx={{ flexGrow: 1}} >
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2.5}>

                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <Item>INFORME</Item>
                                        </Grid>
                                        <Grid item xs={2}>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.busqueda.codigo} onChange={this.manejarCambiosDatos}>
                                                    <option value=''></option>
                                                    {this.state.codigosInforme.map((name) =>
                                                        <option
                                                        key={name.idCodigoMovimiento}
                                                        value={name.idCodigoMovimiento}
                                                        >{name.descripcion}</option>
                                                        )}
                                                </select>
                                        </Grid>
                                        <Grid item xs={1.5}>
                                            <button className="btn btn-outline-primary" type='submit'>Consultar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </form>
                        }
                        <br/>
                        {this.state.consulta && (!this.state.modalConsulta)
                        ?
                            <Container>
                                <FormControlLabel label='Todos' control={<Checkbox checked={this.state.checkInformes.todos} onChange={this.cambioListadoConsulta} id='todos'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                                <FormControlLabel label='Notificados' control={<Checkbox checked={this.state.checkInformes.notificados} onChange={this.cambioListadoConsulta} id='notificados'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                                <FormControlLabel label='Pendientes' control={<Checkbox checked={this.state.checkInformes.pendientes} onChange={this.cambioListadoConsulta} id='pendientes'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                                <FormControlLabel label='Pendiente Notificar' control={<Checkbox checked={this.state.checkInformes.pendienteNotificacion} onChange={this.cambioListadoConsulta} id='pendienteNotificacion'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                                <FormControlLabel label='Rechazados (Ya notificado)' control={<Checkbox checked={this.state.checkInformes.rechazados} onChange={this.cambioListadoConsulta} id='rechazados'  inputProps={{ 'aria-label': 'controlled' }} />  }/>
                                <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                    <Table sx={{minWidth: 700}} id="tablaConsulta">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Informe</StyledTableCell>
                                                <StyledTableCell>Número</StyledTableCell>
                                                <StyledTableCell>Nombre</StyledTableCell>
                                                <StyledTableCell>Estado</StyledTableCell>
                                                <StyledTableCell>Desde</StyledTableCell>
                                                <StyledTableCell>Hasta</StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.informesAListar.slice(this.state.pagina * this.state.filasPorPagina, this.state.pagina * this.state.filasPorPagina + this.state.filasPorPagina).map((name) => (
                                                <StyledTableRow key={name.idInformes}>
                                                    {this.state.codigosInforme.map((name2) => {
                                                        if(name2.idCodigoMovimiento === name.codigo){
                                                            desc = name2.descripcion;
                                                        }
                                                    })}
                                                    <StyledTableCell>{desc}</StyledTableCell>
                                                    <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                                    <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                                    {desc = ''}
                                                    {this.state.codigosEstadosInforme.map((name3) => {
                                                        if(name3.idCodigosEstadoInformes === name.finalizado){
                                                            desc = name3.descripcion;
                                                        }
                                                    })}
                                                    <StyledTableCell>{desc}</StyledTableCell>
                                                    <StyledTableCell>{name.desde.substring(8,10) + '/' + name.desde.substring(5,7) + '/' + name.desde.substring(0,4)}</StyledTableCell>
                                                    {name.hasta === null ? <StyledTableCell></StyledTableCell> : <StyledTableCell>{name.hasta.substring(8,10) + '/' + name.hasta.substring(5,7) + '/' + name.hasta.substring(0,4)}</StyledTableCell>}
                                                    <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarConsulta(name)}>Consultar</button></StyledTableCell>
                                                    {name.finalizado === 2 || name.finalizado === 3 || name.finalizado === 4 || name.finalizado === 9 || name.finalizado === 17
                                                    ?
                                                        <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarEnvioNotificacion(name)}>Notificarme</button></StyledTableCell>
                                                    :
                                                        <StyledTableCell></StyledTableCell>
                                                    }
                                                </StyledTableRow>
                                            ))
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination rowsPerPageOptions={opcionesFilasPorPagina} component="div" count={filasTotales} rowsPerPage={this.state.filasPorPagina} page={this.state.pagina} onPageChange={this.handleChangePage} onRowsPerPageChange={this.handleChangeRowsPerPage} labelRowsPerPage="Filas por página" SelectProps={{inputProps: {'aria-label': 'Filas por página',}, displayEmpty: true,}}/>
                                <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarVolver}>Volver</button>
                            </Container>
                        :
                            null
                        }
                    </Container>
                :
                    <Redirect to='/login'/>
                }
                {this.state.modalConsulta
                ?
                    <Container>
                        <h3>Informes</h3>
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                {this.state.codigosInforme.map((name2) => {
                                    if(name2.idCodigoMovimiento === this.state.datoEspecifico.codigo){
                                        desc = name2.descripcion;
                                    }
                                })}
                                <Grid item xs={4}>
                                </Grid>
                                <Grid item xs={4}>
                                    {desc}
                                </Grid>
                                <Grid item xs={4}>
                                </Grid>
                                {/*Esto va siempre */}
                                <Grid item xs={2}>
                                </Grid>
                                {this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 44 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 66
                                ?
                                    <Grid item xs={2}>
                                        <Item>Certificado (Imagen)</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 10
                                ?
                                    <Grid item xs={2}>
                                        <Item>Constancia de Domicilio</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 75
                                ?
                                    <Grid item xs={2}>
                                        <Item>Comprobante (Imagen)</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 10 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 21
                                ?
                                    this.state.datoEspecifico.esPDF
                                    ?
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.archivoBPS)}>Descargar</button>
                                        </Grid>
                                    :
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                        </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 10 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 44 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 66
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 75
                                ?
                                    this.state.datoEspecifico.esPDF
                                    ?
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.archivoBPS)}>Descargar</button>
                                        </Grid>
                                    :
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                        </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={2}>
                                        <Item>Certificado De Parentesco (Imagen)</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 11
                                ?
                                    this.state.datoEspecifico.esPDF
                                    ?
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.archivoActa)}>Descargar</button>
                                        </Grid>
                                    :
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoActa)}>Ver</button>
                                        </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={2}>
                                        <Item>Familiar</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 4
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.familiar}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 4|| this.state.datoEspecifico.codigo === 42
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 60
                                ?
                                    <Grid item xs={2}>
                                        <Item>{this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 10 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 62 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 53 ? 'Día' : 'Desde'}</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 75
                                ?
                                    <Grid item xs={2}>
                                        {String(this.state.datoEspecifico.desde).substring(8,10) + '/' + String(this.state.datoEspecifico.desde).substring(5,7) + '/' + String(this.state.datoEspecifico.desde).substring(0,4)}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.marca1}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 30
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 56
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37
                                ?
                                    <Grid item xs={2}>
                                        <Item>Hasta</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37
                                ?
                                    <Grid item xs={2}>
                                        {String(this.state.datoEspecifico.hasta).substring(8,10) + '/' + String(this.state.datoEspecifico.hasta).substring(5,7) + '/' + String(this.state.datoEspecifico.hasta).substring(0,4)}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.marca2}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 3 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 60
                                ?
                                    <Grid item xs={2}>
                                        <Item>Día</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 60
                                ?
                                    <Grid item xs={2}>
                                        {String(this.state.datoEspecifico.desde).substring(8,10) + '/' + String(this.state.datoEspecifico.desde).substring(5,7) + '/' + String(this.state.datoEspecifico.desde).substring(0,4)}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 80 || this.state.datoEspecifico.codigo === 71 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 20
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 66
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Días</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 66
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.dias}
                                    </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 80) || (this.state.datoEspecifico.codigo === 71) || (this.state.datoEspecifico.codigo === 1) || (this.state.datoEspecifico.codigo === 67) || (this.state.datoEspecifico.codigo === 2) || (this.state.datoEspecifico.codigo === 37) || (this.state.datoEspecifico.codigo === 40) || (this.state.datoEspecifico.codigo === 35) || (this.state.datoEspecifico.codigo === 56) || (this.state.datoEspecifico.codigo === 14) || (this.state.datoEspecifico.codigo === 15) || (this.state.datoEspecifico.codigo === 16) || (this.state.datoEspecifico.codigo === 17) || (this.state.datoEspecifico.codigo === 20)
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.horasEntradas.map((name) => {
                                    if(this.state.datoEspecifico.entrada === name.idEntrada){
                                        entradaIn = name.descripcion;
                                }})}
                                {this.state.horasEntradas.map((name) => {
                                    if(this.state.datoEspecifico.salida === name.idEntrada){
                                        salidaIn = name.descripcion;
                                }})}
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                        <Item>Entrada</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                        {entradaIn}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                        <Item>Salida</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                        {salidaIn}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 3 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 71 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 14 && this.state.datoEspecifico.codigo !== 16 && this.state.datoEspecifico.codigo !== 17 && this.state.datoEspecifico.codigo !== 15 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 29 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 51 && this.state.datoEspecifico.codigo !== 22 && this.state.datoEspecifico.codigo !== 23 && this.state.datoEspecifico.codigo !== 20 && this.state.datoEspecifico.codigo !== 57 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 35 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 107 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 108 && this.state.datoEspecifico.codigo !== 5 && this.state.datoEspecifico.codigo !== 52 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 48 && this.state.datoEspecifico.codigo !== 56 && this.state.datoEspecifico.codigo !== 66
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Ejercicio (AÑO)</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 3 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 71 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 14 && this.state.datoEspecifico.codigo !== 16 && this.state.datoEspecifico.codigo !== 17 && this.state.datoEspecifico.codigo !== 15 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 29 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 51 && this.state.datoEspecifico.codigo !== 22 && this.state.datoEspecifico.codigo !== 23 && this.state.datoEspecifico.codigo !== 20 && this.state.datoEspecifico.codigo !== 57 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 35 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 107 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 108 && this.state.datoEspecifico.codigo !== 5 && this.state.datoEspecifico.codigo !== 52 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 48 && this.state.datoEspecifico.codigo !== 56 && this.state.datoEspecifico.codigo !== 66
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.anio}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 2 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 110
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Minutos</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.minutos}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Juzgado</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 10
                                ?
                                    <Grid item xs={2}>
                                            
                                    </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52)
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52)
                                ?
                                    <Grid item xs={2}>
                                        <Item>Asignatura</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52)
                                ?
                                    <Grid item xs={1}>
                                        {this.state.datoEspecifico.juzgado}
                                    </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52) && ((this.state.datoEspecifico.finalizado === 12) || (this.state.datoEspecifico.finalizado === 13) || (this.state.datoEspecifico.finalizado === 14) || (this.state.datoEspecifico.finalizado === 14))
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52) && ((this.state.datoEspecifico.finalizado === 12) || (this.state.datoEspecifico.finalizado === 13) || (this.state.datoEspecifico.finalizado === 14) || (this.state.datoEspecifico.finalizado === 14))
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52) && ((this.state.datoEspecifico.finalizado === 12) || (this.state.datoEspecifico.finalizado === 13) || (this.state.datoEspecifico.finalizado === 14) || (this.state.datoEspecifico.finalizado === 14))
                                ?
                                    <Grid item xs={2}>
                                        <Item>Comprobante</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52) && ((this.state.datoEspecifico.finalizado === 12) || (this.state.datoEspecifico.finalizado === 13) || (this.state.datoEspecifico.finalizado === 14) || (this.state.datoEspecifico.finalizado === 14))
                                ?
                                    this.state.datoEspecifico.esPDF
                                    ?
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.archivoBPS)}>Descargar</button>
                                        </Grid>
                                    :
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                        </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52) && ((this.state.datoEspecifico.finalizado === 12) || (this.state.datoEspecifico.finalizado === 13) || (this.state.datoEspecifico.finalizado === 14) || (this.state.datoEspecifico.finalizado === 18))
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 10
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Nueva Dirección</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 10
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.juzgado}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 30) || (this.state.datoEspecifico.codigo === 60) || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 62
                                ?
                                    <Grid item xs={2}>
                                        <Item>Tipo Omisión</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 62
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.tipo}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Tipo Salida</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 37
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.tipo}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 37
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?    
                                    <Grid item xs={2.1}>
                                        <Item>Entrada</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?    
                                    <Grid item xs={2.1}>
                                        <Item>Salilda</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?    
                                    <Grid item xs={2.1}>
                                        <Item>Entrada</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 109
                                ?
                                    <Grid item xs={2.1}>
                                        <Item>Concepto</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 109
                                ?
                                    <Grid item xs={2.1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?    
                                    <Grid item xs={2.1}>
                                        <Item>Salilda</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 110
                                ?
                                    <Grid item xs={2}>
                                        <Item>Día</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 110
                                ?
                                    <Grid item xs={2}>
                                        {String(this.state.datoEspecifico.desde).substring(8,10) + '/' + String(this.state.datoEspecifico.desde).substring(5,7) + '/' + String(this.state.datoEspecifico.desde).substring(0,4)}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 110
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 74
                                ?
                                    <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                        <Table sx={{minWidth: 700}}>
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell>Lunes</StyledTableCell>
                                                    <StyledTableCell>Martes</StyledTableCell>
                                                    <StyledTableCell>Miercoles</StyledTableCell>
                                                    <StyledTableCell>Jueves</StyledTableCell>
                                                    <StyledTableCell>Viernes</StyledTableCell>
                                                    <StyledTableCell>Sábado</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <StyledTableRow>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.entradaLunes === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.entradaMartes === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.entradaMiercoles === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.entradaJueves === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.entradaViernes === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.entradaSabado === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                </StyledTableRow>
                                                <StyledTableRow>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.salidaLunes === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.salidaMartes === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.salidaMiercoles === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.salidaJueves === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.salidaViernes === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.salidaSabado === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                </StyledTableRow>
                                                <StyledTableRow>
                                                    <StyledTableCell></StyledTableCell>
                                                    <StyledTableCell></StyledTableCell>
                                                    <StyledTableCell>Desde</StyledTableCell>
                                                    <StyledTableCell>{String(this.state.datoEspecifico.desde).substring(8,10) + '/' + String(this.state.datoEspecifico.desde).substring(5,7) + '/' + String(this.state.datoEspecifico.desde).substring(0,4)}</StyledTableCell>
                                                    <StyledTableCell></StyledTableCell>
                                                    <StyledTableCell></StyledTableCell>
                                                </StyledTableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                :
                                    null
                                }
                            </Grid>
                        </Box>
                        <br/>
                        {this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 60 ? <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={10} cols={40} id='comentarios' value={this.state.datoEspecifico.comentarios} disabled/> : null}
                        {this.state.datoEspecifico.motivoRechazo !== null && this.state.datoEspecifico.motivoRechazo !== '' ? <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={10} cols={40} id='motivoRechazo' value={this.state.datoEspecifico.motivoRechazo} disabled/> : null}
                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Volver</button>
                    </Container>

                :
                    null
                }
                {this.state.imagenMostrarModal
                ?
                    <Modal open={this.state.imagenMostrarModal}>
                        <Box sx={styleModal} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <img src={this.state.imagenMostrar} alt="" style={{ width: '90%'}}/>
                                <Grid item xs={5}>
                                    
                                </Grid>
                                <Grid item xs={2}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarCerrarModal}>Cerrar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Modal>
                :
                    null
                }
            </>
        )//Final return
    }//Final render

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            informesSolicitados: [],
            consulta: false,
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    async manejoEnvioConsulta(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([sessionStorage.lugar,sessionStorage.lugarCentral, this.state.busqueda]);

        const infoSol = await fetch(`${Constantes.RUTA_API}/obtener_informesSolicitadosUsuario.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const datosInfoSol = await infoSol.json();
        if(datosInfoSol[0].length !== 0){
            this.setState({
                informesSolicitados: datosInfoSol[0],
                informesAListar: datosInfoSol[0],
                informesPendientes: datosInfoSol[2],
                informesNotificados: datosInfoSol[1],
                informesPendientesNotificacion: datosInfoSol[3],
                informesRechazados: datosInfoSol[4],
                consulta: true,
            });
        }else{
            this.setState({
                errores: 'No hay datos para la consulta realizada!',
                informesSolicitados: [],
            })
        }
    }

    manejarConsulta(dato){
        this.setState({
            modalConsulta: true,
            datoEspecifico: dato,
        })
    }

    cerrarModal(e){
        e.preventDefault();
        //this.obtenerCal();
        this.setState({
            modalConsulta: false,
        });
    }

    async manejarEnvioNotificacion(dato){
        const cargaUtil = JSON.stringify([sessionStorage.lugar,sessionStorage.lugarCentral, dato]);

        const infoSol = await fetch(`${Constantes.RUTA_API}/notificar_informe.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await infoSol.json();

        this.setState({
            errores: res[0],
        })

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Notificado correctamente',
                informesSolicitados: [],
                consulta: false,
            })
        }
    }

    cambioListadoConsulta(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.checked;

        if(clave === 'todos'){

            if(valor){
                this.setState({
                    checkInformes: {
                        todos: true,
                        pendientes: false,
                        notificados: false,
                        rechazados: false,
                        pendienteNotificacion: false,
                    },
                });
                this.setState(state => {
                    const numFunActualizado = state.informesSolicitados;
                    //numFunActualizado[clave] = valor;
                    
                    return{
                        informesAListar: numFunActualizado,
                    };
                });
            }
        }else if(clave === 'pendientes'){
            if(valor){
                this.setState({
                    checkInformes: {
                        todos: false,
                        pendientes: true,
                        notificados: false,
                        rechazados: false,
                        pendienteNotificacion: false,
                    },
                });
                this.setState(state => {
                    const numFunActualizado = state.informesPendientes;
                    //numFunActualizado[clave] = valor;
                    
                    return{
                        informesAListar: numFunActualizado,
                    };
                });
            }
        }else if(clave === 'notificados'){
            if(valor){
                this.setState({
                    checkInformes: {
                        todos: false,
                        pendientes: false,
                        notificados: true,
                        rechazados: false,
                        pendienteNotificacion: false,
                    },
                });
                this.setState(state => {
                    const numFunActualizado = state.informesNotificados;
                    //numFunActualizado[clave] = valor;
                    
                    return{
                        informesAListar: numFunActualizado,
                    };
                });
            }
        }else if(clave === 'rechazados'){
            if(valor){
                this.setState({
                    checkInformes: {
                        todos: false,
                        pendientes: false,
                        notificados: false,
                        rechazados: true,
                        pendienteNotificacion: false,
                        //informesSolicitados: this.state.informesRechazados,
                    },
                });
                this.setState(state => {
                    const numFunActualizado = state.informesRechazados;
                    //numFunActualizado[clave] = valor;
                    
                    return{
                        informesAListar: numFunActualizado,
                    };
                });
            }
        }else if(clave === 'pendienteNotificacion'){
            if(valor){
                this.setState({
                    checkInformes: {
                        todos: false,
                        pendientes: false,
                        notificados: false,
                        rechazados: false,
                        pendienteNotificacion: true,
                    },
                });
                this.setState(state => {
                    const numFunActualizado = state.informesPendientesNotificacion;
                    //numFunActualizado[clave] = valor;
                    
                    return{
                        informesAListar: numFunActualizado,
                    };
                });
            }
        }
    }

    manejarVolver(e){
        e.preventDefault();
        this.setState({
            consulta: false,
            modalConsulta: false,
            informesSolicitados: [],
            informesPendientes: [],
            informesNotificados: [],
            informesPendientesNotificacion: [],
            informesRechazados: [],
        })
    }

    manejarModalImagen(dato){
        this.setState({
            imagenMostrarModal: true,
            imagenMostrar: dato,
        })
    }

    manejarCerrarModal(e){
        e.preventDefault();
        this.setState({
            imagenMostrarModal: false,
            imagenMostrar: '',
        })
    }
}

export default ConsultaInformesUsuarios